import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import {Button, ButtonGroup } from "react-bootstrap";
import ImageHotspots from "../../../components/ImageHotspot/ImageHotspots";
import {connect} from "react-redux";
import {modalActions} from "../../../actions/modal.actions";
import ExhibitionMapForm from "./_forms/ExhibitionMapForm";
import {exhibitionMapActions} from "../../../actions/exhibition-map.actions";
import {Link} from "react-router-dom";
import {claimTypes} from "../../../constants/claim.constants";


class ExhibitionMapPage extends Component {

    state = {
        loading: true,
        currentFloor: 0,
        rooms: []
    };

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(exhibitionMapActions.getRooms());
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.roomsList !== this.props.roomsList) {
            this.setState({
                ...this.state,
                loading: false,
                rooms: this.props.roomsList
            });
        }
    }

    onChangeFloor = (floorIndex) => {
        this.setState({
            ...this.state,
            currentFloor: floorIndex,
            loading: true
        });

        setTimeout(() => {
            this.setState({
                ...this.state,
                loading: false
            })
        })
    };

    addHotSpot = (cords) => {
        const { t, user, dispatch } = this.props;
        const modalProps = {
            open: true,
            title: t('add_exhibition-map-point'),
            component: user['c_map.actions.crud'] === claimTypes.READ_WRITE ?
                (<ExhibitionMapForm data={cords} submitForm={this.onSubmitCreateHotspot}/>) :
                (<h5>{t('msg.not-permission')}</h5>),
        };

        dispatch(modalActions.showModal({
            modalProps: modalProps,
            modalType: 'formModal'
        }));
    };

    onSubmitCreateHotspot = (data) => {
        const { dispatch } = this.props;
        const { rooms, currentFloor } = this.state;
        const selectedRoom = rooms[currentFloor];

        data.roomId = selectedRoom.id;

        dispatch(exhibitionMapActions.createHotspot(data));
    };

    render() {
        const breadcrumb = [{ value: 'exhibition-map', path: '#' }];

        const { t, user } = this.props;
        const { rooms, currentFloor } = this.state;

        const selectedRoom = rooms[currentFloor];
        const claimExhibitionMap = user['c_map.actions.crud'] || null;

        return (
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <div className="row">
                    <h4 className="col-md-6">{t('exhibition-map')}</h4>
                     <div className="col-md-6 text-right">
                         { claimExhibitionMap === claimTypes.READ_WRITE ? (
                             <Link to={"/panel/exhibition-map/config"}>
                                 <Button
                                     className="text-right"
                                     size={"sm"}
                                     variant={"outline-secondary"} onClick={() => this.onClickConfigMap }>
                                     { t('config') } <i className="fas fa-cogs" />
                                 </Button>
                             </Link>
                         ) : (<React.Fragment/>) }
                     </div>

                </div>


                { rooms && rooms.length > 0 ? (
                    <React.Fragment>
                        <ButtonGroup size={"sm"}>
                            { rooms.map((item, idx) => (
                                <Button
                                    key={idx}
                                    className={item.id === selectedRoom.id ? "active": ""}
                                    variant={"primary"}
                                    onClick={() => this.onChangeFloor(idx) }>
                                    { item.label }
                                </Button>
                            )) }
                        </ButtonGroup>

                        <div className="mt-2 map-container">
                            { !this.state.loading ? (
                                <ImageHotspots
                                    src={selectedRoom.imageSrc}
                                    alt={selectedRoom.label}
                                    hotspots={selectedRoom.mapHotspots}
                                    onAddedHotspot={this.addHotSpot}
                                />
                            ) : (<React.Fragment/>) }
                        </div>
                    </React.Fragment>
                ) : (
                    <div className="border mt-5">
                        <h4 className="text-center p-4">
                            {t("exhibition-map-is-not-define")}
                        </h4>
                    </div>
                )}


            </div>
        )
    }
}

const mapStateToProps = state => {
    const { roomsList } = state.exhibitionMapReducer;
    const { user } = state.authenticationReducer;
    return {
        roomsList,
        user
    }
};
export default withNamespaces()(connect(mapStateToProps)(ExhibitionMapPage));
